import actions from './actions'
import state from './state'
import getters from './getters'
import mutations from './mutations'

export default {
  name: 'user',
  namespaced: true,
  actions,
  state,
  getters,
  mutations
}